import { IGatsbyImageData } from "gatsby-plugin-image"

export interface ContentfulCta {
  href: string
  anchorText: string
}

export interface ContentfulIcon {
  file: {
    url: string
  }
}

export interface ContentfulChildMarkdownRemark {
  childMarkdownRemark: {
    html: string
  }
}

export interface ContentfulLogoImage {
  image: {
    file: {
      url: string
    }
  }
  name: string
}

export interface ContentfulSSLPImage {
  file?: {
    url: string
  }
  gatsbyImage: IGatsbyImageData
  constrained?: IGatsbyImageData
  fixed?: IGatsbyImageData
  fluid?: IGatsbyImageData
  resize?: { src: string }
}

export interface ContentfulSSLPForm {
  id: string
  marketoFormCampaignObject: {
    formId: string
    name: string
  }
  thankYouMessage: ContentfulChildMarkdownRemark
}

export interface ContentfulSelfServicePageContent {
  contentful_id?: string
  name: string
  primaryText: string
  secondaryText?: string
  videoEmbedId?: string
  description?: ContentfulChildMarkdownRemark
  images?: ContentfulSSLPImage[]
  ctas?: ContentfulCta[]
  icon?: ContentfulIcon
  logos?: ContentfulLogoImage[]
  form?: ContentfulSSLPForm
}

export interface ContentfulSelfServicePageResourceList {
  heading?: string
  description?: string
  contentType: string
  persona?: string
  limit?: number
}

export interface SelfServicePageAppearance {
  theme: string
  backgroundImages: ContentfulSSLPImage[]
  verticalMargin: string
}

export enum Alignment {
  Left = "left",
  Center = "center",
  Right = "right",
}

export interface ContentfulSelfServicePageSection {
  layout: string
  alignment: Alignment
  content: ContentfulSelfServicePageContent &
    ContentfulSelfServicePageResourceList
  items: ContentfulSelfServicePageContent[]
  appearance: SelfServicePageAppearance
}

// Types for utils

export type GetImageProps = {
  file?: {
    url: string
  }
  name?: string
}

export type GetCtaProps = {
  ctas?: ContentfulCta[]
}

export type GetHtmlProps =
  | ContentfulChildMarkdownRemark
  | (ContentfulChildMarkdownRemark & string)
